import { useEffect, useState } from "react";

/**
 * Hook compartilhado entre o banner automático e o botão "Instalar app".
 * Retorna:
 *  - available: se dá para instalar por aqui (Android/Chrome com beforeinstallprompt OU iOS Safari não-standalone)
 *  - isIOS: true quando é iOS Safari (precisa mostrar instruções manuais)
 *  - install(): chama o prompt nativo se disponível; retorna choice.outcome ("accepted"/"dismissed") ou null se não disponível
 */
export function useInstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [standalone, setStandalone] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", handler);

    const ua = window.navigator.userAgent || "";
    const iOS = /iPhone|iPad|iPod/.test(ua);
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    setIsIOS(iOS);
    setStandalone(isStandalone);

    const onInstalled = () => setDeferred(null);
    window.addEventListener("appinstalled", onInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const available = !standalone && (Boolean(deferred) || isIOS);

  const install = async () => {
    if (!deferred) return null;
    deferred.prompt();
    const choice = await deferred.userChoice;
    setDeferred(null);
    return choice?.outcome || null;
  };

  return { available, isIOS, standalone, hasNativePrompt: Boolean(deferred), install };
}
